import { render, staticRenderFns } from "./ViewLocationComponent.vue?vue&type=template&id=5f47915f"
import script from "./ViewLocationComponent.vue?vue&type=script&lang=js"
export * from "./ViewLocationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports